import type { ReactNode } from 'react';

// Shared "guided empty state" for panels waiting on a link, selection, or data:
// an accent icon, a short headline (what the panel does), and a one-line
// next-step. Use `fill` to centre it in a full-panel empty body; omit it for an
// inline empty that sits in a control panel's flow. On-brand (accent-100 chip,
// FT-restrained).
export function PanelEmptyState({
  icon,
  title,
  children,
  fill,
}: {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  fill?: boolean;
}) {
  const block = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--s-3)',
        maxWidth: 430,
        alignItems: fill ? 'center' : 'flex-start',
        textAlign: fill ? 'center' : 'left',
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          display: 'grid',
          placeItems: 'center',
          background: 'var(--color-accent-100)',
          color: 'var(--accent)',
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
      <div
        style={{
          fontSize: '16px',
          fontWeight: 700,
          color: 'var(--text-primary)',
          lineHeight: 1.15,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 'var(--t-body)', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
        {children}
      </div>
    </div>
  );
  if (fill) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--s-4)',
          boxSizing: 'border-box',
        }}
      >
        {block}
      </div>
    );
  }
  return <div style={{ padding: 'var(--s-3) 0' }}>{block}</div>;
}
